import * as React from 'react';
import { cn } from '../../lib/utils';

const tableRowClassName =
  'transition-colors hover:bg-[var(--ba-hover-subtle)]';

const tableRowSelectedClassName =
  '!bg-[var(--ba-table-row-selected-bg)] hover:!bg-[var(--ba-table-row-selected-hover)] [&_td:first-child]:shadow-[inset_3px_0_0_0_#F68B1F]';

function Table({ className, framed = true, ...props }) {
  return (
    <div
      className={cn(
        'relative w-full overflow-x-auto',
        framed && 'rounded-xl border border-[var(--ba-surface-border)]'
      )}
    >
      <table className={cn('w-full min-w-full caption-bottom text-sm', className)} {...props} />
    </div>
  );
}

function TableHeader({ className, ...props }) {
  return (
    <thead
      className={cn(
        'bg-[var(--ba-table-header-bg)] [&_th]:border-b [&_th]:border-[var(--ba-surface-border)]',
        className
      )}
      {...props}
    />
  );
}

function TableBody({ className, ...props }) {
  return (
    <tbody
      className={cn(
        '[&_tr:nth-child(even)]:bg-[var(--ba-table-row-stripe)]',
        '[&_td]:border-b [&_td]:border-[var(--ba-surface-border)]',
        className
      )}
      {...props}
    />
  );
}

function TableRow({ className, ...props }) {
  return <tr className={cn(tableRowClassName, className)} {...props} />;
}

function TableHead({ className, ...props }) {
  return (
    <th
      className={cn(
        'h-9 whitespace-nowrap px-3 py-2 text-left align-middle text-[11px] font-semibold uppercase tracking-wide text-[var(--ba-muted)]',
        className
      )}
      {...props}
    />
  );
}

function TableCell({ className, ...props }) {
  return (
    <td
      className={cn(
        'min-w-[120px] max-w-[420px] px-3 py-2 align-middle text-sm text-[var(--ba-body-text)] whitespace-normal break-words',
        className
      )}
      {...props}
    />
  );
}

export { Table, TableHeader, TableBody, TableRow, TableHead, TableCell, tableRowClassName, tableRowSelectedClassName };
